export default {
    search: 'Szukaj',
    enter_the_city: 'Wprowadź miasto',
    to_download: 'Do pobrania',
    make_an_appointment: 'Umów się na wizytę',
    only_with: 'Tylko z',
    calculate_route: 'Wyznacz trasę',
    e_conference: 'E-konsultacja',
    safe_appointment: 'Bezpieczna wizyta w salonie'
}
